export const getValue = <T extends object, K extends keyof T>(
  object: T,
  key: K
): T[K] => {
  const value = object[key]

  if (value === undefined) {
    throw new Error(`Key ${String(key)} does not exist on object`)
  }

  return value
}
